<template>
  <div class="wrapper">
    <div class="container">
      <footer>
        <div class="copyright">
          Copyright © {{ year }} 江苏大国工匠工业研究院有限公司 版权所有
          <a class="record" target="_blank" href="https://beian.miit.gov.cn">苏ICP备2025194317号-3</a>
          <a target="_blank"
            href="https://xyt.xcc.cn/getpcInfo?sn=1971160087246376960&amp;certType=8&amp;url=www.123-ai.cn&amp;language=CN">
            <img class="xcc" src="https://program.xinchacha.com/xyt/xcc_small_ssl.png">
          </a>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: "ros-admin-footer",
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>

<style lang="scss" scoped>
footer {
  margin: 0 auto;
  width: 100%;
  padding-bottom: 10px;

  .copyright {
    padding: 14px 0;
    font-size: 12px;
    color: #ffffff;
    text-align: center;
    opacity: 0.9;

    a {
      color: #ffffff;

      &:hover {
        color: #26acf1;
      }
    }
  }

  .xcc {
    margin-left: 5px;
    vertical-align: text-bottom;
    width: 16px;
    height: 16px;
  }
}
</style>
